import { MouseEvent, useState } from 'react';

export type ActionModalType =
  | 'call'
  | 'reminderAction'
  | 'incident'
  | 'event'
  | 'quoteReceived'
  | 'quoteApproved'
  | 'documents'
  | 'other'
  | 'reminder';

export function useAddActions() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [activeModal, setActiveModal] = useState<ActionModalType | null>(null);

  const isMenuOpen = Boolean(anchorEl);

  function handleOpenMenu(event: MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleCloseMenu() {
    setAnchorEl(null);
  }

  function handleSelectAction(type: ActionModalType) {
    setActiveModal(type);
    handleCloseMenu();
  }

  function handleCloseModal() {
    setActiveModal(null);
  }

  return {
    anchorEl,
    isMenuOpen,
    activeModal,
    handleOpenMenu,
    handleCloseMenu,
    handleSelectAction,
    handleCloseModal,
  };
}

